<template>
  <div
    v-image-modal="enableImageModal"
    class="mark-down-hj"
    :class="{ 'image-modal-enabled': enableImageModal }"
    v-html="renderedMarkdown"
  ></div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import { sanitizeHtml } from '@/components/sanitize.js';

export default {
  name: 'MD',
  props: {
    contents: { type: String, default: '' },
    enableImageModal: { type: Boolean, default: false }
  },
  data() {
    return {
      md: new MarkdownIt({
        html: true,
        breaks: true,
        linkify: true
      })
    };
  },
  computed: {
    renderedMarkdown() {
      if (!this.contents) return '';
      const rendered = this.md.render(this.contents);
      return sanitizeHtml(rendered);
    }
  }
};
</script>

<style>
/* mark-down-hj base styles are in custom.css - unified with mark-down-sb */
.mark-down-hj.image-modal-enabled img {
  cursor: pointer;
}
</style>
